export enum ViewSendingStatus{
    SENT = "SENT",
    NOT_SENT = "NOT_SENT",
    ERROR = "ERROR"
}
